import axios, { AxiosResponse } from 'axios';
import { BaseService } from './BaseService';
import { SchoolEvent, SchoolEventUser } from './types/schoolevents';

export * from './types/schoolevents';

export default class SchoolEventService extends BaseService {
    constructor() {
        super('content/schoolevent');
    }

    async getSchoolEvent(id: string): Promise<SchoolEvent> {
        const event = await axios({
            method: 'GET',
            url: this.getUrl('events/' + id.toString()),
        }).then(res => res.data);

        return {
            ...event,
            startTime: new Date(event.startTime),
            endTime: new Date(event.endTime),
        };
    }

    async getSchoolEvents(): Promise<SchoolEvent[]> {
        const res = await axios({
            method: 'GET',
            url: this.getUrl('events'),
        });

        return res.data.map((event: SchoolEvent) => ({
            ...event,
            startTime: new Date(event.startTime),
            endTime: new Date(event.endTime),
        }));
    }

    async getMySchoolEvents(): Promise<SchoolEventUser[]> {
        const res = await axios({
            method: 'GET',
            url: this.getUrl('me'),
        });

        return res.data ? res.data : [];
    }

    async createSignup(schoolEventId: string): Promise<AxiosResponse> {
        return axios({
            method: 'POST',
            url: this.getUrl('signups'),
            data: {
                schoolEventId: schoolEventId,
            },
        });
    }

    async deleteSignup(schoolEventId: string): Promise<AxiosResponse> {
        return axios({
            method: 'DELETE',
            url: this.getUrl('signups'),
            data: {
                schoolEventId: schoolEventId,
            },
        });
    }
}
